import axios from "axios";
import { TTP_API_URL } from "Config";

export const getCategories = ({ token, communityId, lng, dir }) => {
  let filter = [
    //TODO à activer aprés la mise en place des trees
    /*{
      property: "organization",
      operator: "eq",
      value: communityId
    },*/
    {
      property: "type",
      operator: "like",
      value: "MEDIA"
    }
  ];

  let sort = [];
  const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
  if (dir !== "DESC" && dir !== "ASC")
    sort.push({
      property: "counter",
      dir: "desc"
    });
  else
    sort.push({
      property: nameAttr,
      dir: dir
    });

  const fields = ["*"];
  const requestUrl = `${TTP_API_URL}/media/category`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      limit: 200,
      start: 0
    }
  });
};

export const saveCategory = ({
  token,
  lng,
  id,
  community,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  color,
  isPersonal,
  mediaIds
}) => {
  const requestUrl = `${TTP_API_URL}/media/category`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organization", community.id);
  titleFR && formData.append("titleFr", titleFR);
  titleEN && formData.append("titleEn", titleEN);
  titleNL && formData.append("titleNl", titleNL);
  descriptionFR && formData.append("descriptionFr", descriptionFR);
  descriptionEN && formData.append("descriptionEn", descriptionEN);
  descriptionNL && formData.append("descriptionNl", descriptionNL);
  color && formData.append("color", color);
  formData.append("isPersonal", isPersonal ? 1 : 0);
  id && formData.append("id", id);
  mediaIds && formData.append("media_ids", JSON.stringify(mediaIds));

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/category.js